export default "__VITE_ASSET__460129f3__"